import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTrackGeneratedShareUrl } from '@air/analytics';
import { ShortUrl } from '@air/api';
import { ShortUrlObjectType } from '@air/api/types';
import { reportErrorToBugsnag } from '@air/utils-error';

import { getShortIdInformationKey } from './useGetExistingShortIdInformation';

export const useGetShortIdForBoard = () => {
  const queryClient = useQueryClient();
  const { trackGeneratedShareUrl } = useTrackGeneratedShareUrl();

  return useMutation({
    mutationFn: (params: Parameters<typeof ShortUrl.getShortIdForBoard>[0]) => ShortUrl.getShortIdForBoard(params),
    onSuccess: (data, params) => {
      queryClient.setQueryData(getShortIdInformationKey({ objectId: params.id, boardContext: undefined }), data);

      trackGeneratedShareUrl({
        type: ShortUrlObjectType.board,
        id: data.id,
      });
    },
    onError: (error, params) => {
      throw reportErrorToBugsnag({
        error,
        context: 'Failed to get short id for board',
        metadata: { data: { params } },
      });
    },
  });
};
